var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"headerBreadcrumbs"},[_c('div',{staticClass:"content"},[_c('v-breadcrumbs',{attrs:{"items":_vm.fullPath}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }